<template>
  <v-card>
    <v-card-title>
      <h2 class="headline mb-0">Zakazivanje novog pregleda</h2>
    </v-card-title>
    <v-card-text>
      <v-container>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="selectedDoctor"
              placeholder="Doktor"
              :items="doctors"
            ></v-autocomplete>
          </v-col>
        </v-row>
        <v-row>
          <v-col cols="12" sm="6">
            <v-autocomplete
              v-model="selectedPatient"
              placeholder="Pacijent"
              :items="patients"
              :search-input.sync="search"
              :loading="patientsLoading"
            ></v-autocomplete>
          </v-col>
        </v-row>

        <!-- <v-row>
          <v-col cols="12" sm="6">
            <v-date-picker
              v-model="date"
              :first-day-of-week="1"
              locale="sr-latn"
            ></v-date-picker>
          </v-col>
          <v-col cols="12" sm="6">
            <v-time-picker format="24hr"></v-time-picker>
          </v-col>
        </v-row> -->
      </v-container>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn color="primary" text @click="close">Zatvori</v-btn>
      <v-btn color="primary" text @click="save">Sačuvaj</v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  data() {
    return {
      selectedDoctor: "",
      selectedPatient: "",
      doctors: [],
      patients: [],
      date: "",
      search: null,
      patientsLoading: false,
    };
  },
  async mounted() {
    await this.getDoctors();
  },
  methods: {
    close() {
      this.$emit("close");
    },
    save() {
      this.$emit("save");
    },
    async getDoctors() {
      const res = await this.$http.doctors.getAll();
      this.doctors = res.data.map((doctor) => {
        return {
          text: doctor.firstname + " " + doctor.lastname,
          value: doctor.id,
        };
      });
      console.log(this.doctors);
    },
    async searchPatients(query) {
      this.patientsLoading = true;
      const res = await this.$http.patients.search(query, 1, 20);
      console.log(res);
      this.patients = res.data.map((patient) => {
        return {
          text: patient.firstname + " " + patient.lastname,
          value: patient.id,
        };
      });
      this.patientsLoading = false;
    },
  },
  watch: {
    search: function(val) {
      val && val !== this.selectedPatient && this.searchPatients(val);
    },
  },
};
</script>

<style></style>
